export const GNOME_NAMES = {
  'Branding': 'Kestrel',
  'Strategy': 'Gnomepoleon',
  'Analytics': 'Doug',
  'Campaigns': 'Benjamin',
  'Campaigns & Analytics': 'Benjamin',
  'Email Automation': 'Stampson',
  'Nurture & Automation': 'Stampson',
  'Engagement': 'Gnorm',
  'Butler': 'Jeeves',
  'Chief of Staff': 'Jeeves',
  'Content': 'Jeeves',
  'The Agency': 'Team Chat'
};

export const getGnomeName = (title) => {
  if (!title) return '';
  return GNOME_NAMES[title] || title;
};
